module.exports = "/images/Warning.svg?894938bef13c6b5012f00e8e356a6fc8";